/* Abschluss: Exportplan, Papierkorb und Speicher — Typen für Server und Client */
export interface Geometry {
  trim: { w: number; h: number };                       // Zoll
  bleed: number;                                        // Zoll, 0 ohne Beschnitt
  bleedAll: boolean;                                    // Beschnitt rundum (Canva) statt nur außen, oben, unten (KDP)
  sheet: { w: number; h: number };                      // Blatt = Trim + Beschnitt (außen, oben, unten)
  margins: { top: number; bottom: number; outer: number; inner: number };
  px: { w: number; h: number };                         // Blatt in Pixeln bei 300 dpi
}
export interface ExportPage {
  no: number; type: string; unit: string; pageId: string; unitId: string; status: string;
  versionId: string | null; v: number | null; image: string | null; text: string;
  file: string; model: string | null; quality: string | null;
}
export interface ExportInfo {
  bookId: string; name: string; slug: string; trim: string; binding: string; bleed: boolean;
  geometry: Geometry; dpi: number;
  pages: ExportPage[]; approved: number; total: number; placeholders: number;
  ready: boolean; pdfOk: boolean; hasProfile: boolean;
  zipName: string; pdfName: string; cutMarks: boolean;
}
export interface TrashItem { id: string; name: string; hue: number; deletedAt: string; pages: number; bytes: number; daysLeft: number; }
export interface StorageInfo {
  usedGb: number; totalGb: number; trashDays: number;
  dirs: Record<string, number>;                         // Bytes je Ordner
  superseded: { count: number; bytes: number };          // abgelöste, ungeschützte Versionen
  orphans: { count: number; bytes: number };             // Dateien ohne Verweis
  trash: { count: number; bytes: number };
}
export interface CleanupResult { versions: number; files: number; bytes: number; storage: StorageInfo; }
export interface BackupItem { dir: string; at: string; bytes: number; }
export interface CostSummary { days: number | 'all'; total: number; count: number; byKind: Record<string, number>; approved: number; days14: number[]; }
export interface UserCleanupResult { versions: number; files: number; bytes: number; usedGb: number; }
export interface CostSplit { label: string; count: number; cents: number; }
export interface CostDetail { total: number; count: number; byBook: CostSplit[]; byKind: CostSplit[]; byPage: CostSplit[]; byLabel: CostSplit[]; entries: { created: string; book: string; page: string; kind: string; model: string; quality: string | null; cents: number }[]; }
/* Kostenübersicht: je Buch, je Art, Zeitreihen */
export interface CostOverview {
  total: number; count: number;
  books: { id: string | null; name: string; cents: number; count: number; deleted: boolean }[];
  byKind: Record<string, number>;
  daily: { day: string; cents: number }[];        // letzte 30 Tage
  weekly: { week: string; cents: number }[];      // letzte 26 Wochen (Montag als Schlüssel)
  monthly: { month: string; cents: number }[];    // letzte 6 Monate
}
export const fmtBytes = (n: number) => n >= 1e9 ? (n / 1e9).toFixed(2).replace('.', ',') + ' GB' : n >= 1e6 ? (n / 1e6).toFixed(1).replace('.', ',') + ' MB' : n >= 1e3 ? Math.round(n / 1e3) + ' KB' : n + ' B';
